import { categories } from '@/mocks/home';
import { Link } from 'react-router-dom';

export default function CategoryShowcase() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            十二大热门分类，总有一个是你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center ${cat.color} group-hover:scale-110 transition-transform`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count}个视频
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}